const state = {
    permissions: [],
    loading: false
};

export default state;